// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__pyBEz","wrapper":"Loader_wrapper__7wGW8","loader":"Loader_loader__K57+P","spin":"Loader_spin__7EnT3"};